export const SET_FILTER = "setListenFilter";
export const SET_INFO_STUDIERENDE = "setInfoStudierende";
export const SET_INFO_MITARBEITENDE = "setInfoMitarbeitende";
export const SET_INFO_KUNDEN = "setInfoKunden";
export const SET_INFO_OPENBALANCE = "setInfoDebitoren";
export const SET_INFO_INVOICEDRAFT = "setInvoiceDraft";
export const SET_SPRACHEN = "setSprachen"
